export default {
  suppliers: [],
  supplier: null,
  suppliersFilters: [],
  vPage: 0,
  limit: 50,
  vTotalPages: 0,
}
